import { StateCreator } from "zustand"

import type * as StoreTypes from "@src/types/store"

const initState = {
  isLoading: false,
  loading: null,
}

export const createShareSlice: StateCreator<StoreTypes.StoreState, [], [], StoreTypes.ShareSlice> = (
  set,
) => ({
  ...initState,
  clearLegacyStore: () => {
    set((state) => {
      state.resetInteractions()
      state.resetQuestions()
      state.resetLegacyProfiles()
      state.resetMedia()
      state.resetUsers()
      state.resetConversations()
      state.resetMessages()
      state.resetChatMessages()
      return {}
    })
  },
  setIsLoading: (loading: boolean) => {
    set({ isLoading: loading })
  },
  setLoading: (loading: StoreTypes.ILoading) => {
    set({ loading })
  },
})
